import { useState, useEffect } from "react";
import axios from "axios";
import { Video, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MeetingCard = ({ authHeader }) => {
  const [meeting, setMeeting] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/bdm/meeting`, { headers: authHeader() })
      .then((r) => setMeeting(r.data?.join_url ? r.data : null))
      .catch(() => setMeeting(null));
  }, [authHeader]);

  if (!meeting) return null;

  let when = `${meeting.date} · ${meeting.time} Pacific`;
  try {
    const dt = new Date(`${meeting.date}T${meeting.time}`);
    if (!Number.isNaN(dt.getTime())) {
      when = `${dt.toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric" })} · ${dt.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })} Pacific`;
    }
  } catch {
    /* fall back to raw values */
  }

  return (
    <div className="bg-navy text-white rounded-3xl shadow-soft p-6" data-testid="bdm-meeting-card">
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-lime">
        <Video size={13} /> Partner growth meeting
      </div>
      <h3 className="mt-1 font-heading font-medium text-xl">{meeting.title}</h3>
      <p className="mt-1 text-sm text-white/70">{when}</p>
      {meeting.agenda ? (
        <ul className="mt-3 space-y-1.5">
          {meeting.agenda
            .split("\n")
            .filter((l) => l.trim())
            .slice(0, 4)
            .map((l, i) => (
              <li key={i} className="text-xs text-white/80 leading-relaxed">
                {l.trim().replace(/^[-•]\s*/, "")}
              </li>
            ))}
        </ul>
      ) : null}
      <a
        href={meeting.join_url}
        target="_blank"
        rel="noreferrer"
        data-testid="bdm-meeting-join"
        className="mt-4 inline-flex items-center gap-2 bg-lime text-navy font-semibold text-sm px-5 py-2.5 rounded-full hover:brightness-95"
      >
        Join the meeting <ArrowRight size={15} />
      </a>
    </div>
  );
};

export default MeetingCard;
